<template>
  <div>
    <b-button variant="primary" @click="openFileExplorer">
      Seleccionar
    </b-button>
    <b-modal
      hide-footer
      centered
      no-close-on-backdrop
      ref="filesModal"
      title="Archvios en carpeta"
      size="xl"
    >
      <div class="row mb-5">
        <div class="col-9 scroll">
          <h5 class="mb-5">Archivos</h5>
          <ul>
            <li
              class="cursor-default mb-1 d-flex flex-row"
              v-for="item in []"
              :key="item.id"
            >
              <font-awesome-icon
                :icon="['fas', 'folder']"
                class="orange mt-1"
                v-if="item.type === 'folder'"
              />
              <font-awesome-icon
                :icon="['fas', fileTypeIcon(item)]"
                :class="fileTypeIcon(item)"
                class="mt-1"
                v-if="item.type === 'file'"
              />
              <span class="ml-2">{{item.name}}</span>
              <span> - {{item.owner}}</span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import EDIcons from '@/febos/global/documentManagement/mixins/EDIcons';

export default {
  name: 'AttachExistingFile',
  props: ['uploadType'],
  mixins: [EDIcons],
  methods: {
    ...mapActions('DocManagement', ['loadFiles']),
    openFileExplorer() {
      this.$refs.filesModal.show();
    }
  },
  async created() {
    await this.loadFiles({
      repositoryId: '1775ce27-bbf8-44e9-bef3-2bd7b4229253', // this.repository.repositorioId,
      parentFolder: 'f560f5b4-08ee-4e4b-be3a-0d42844dacff',
      path: 'f560f5b4-08ee-4e4b-be3a-0d42844dacff',
    });
  }
};
</script>
